import { useSuspenseQuery } from "@tanstack/react-query";
import { Ajustes } from "@/components/casca/Ajustes";
import { Equipe as EquipeDaClinica } from "@/components/equipe/Equipe";
import { equipeQuery } from "../consultas";

/** Quem tem acesso a esta clínica, com que papel e quais áreas enxerga. */
export function Equipe() {
  const {
    data: { membros, convites, lugares, ehAdmin },
  } = useSuspenseQuery(equipeQuery());
  return (
    <Ajustes titulo="Equipe" descricao="Quem tem acesso a esta clínica, com que papel e o que enxerga.">
      <EquipeDaClinica membros={membros} convites={convites} lugares={lugares} ehAdmin={ehAdmin} />
    </Ajustes>
  );
}
